import { UpdatableForm } from '../../../../components/Purchasing/SupplierRegistration/Form/Member'
import React, { Component } from 'react'
import { Col, Divider, Form, Row } from 'antd'

class ContractDetails extends Component {
  render() {
    const { getFieldDecorator, setFieldsValue } = this.props.form
    const { supplierRegistration, member } = this.props

    console.log(supplierRegistration)
    return (
      <Form className="steps-content">
        <Divider orientation="left">Trading Details</Divider>
        <Row>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'Tax Number',
                path: 'taxRegistration',
                newData: supplierRegistration,
                newPath: 'business.taxNo',
                oldPath: 'taxRegistration',
                oldData: member,
                required: false,
              }}
            />
          </Col>
          <Col span={12}>
            <UpdatableForm
              {...{
                setFieldsValue,
                getFieldDecorator,
                label: 'DUNS Number',
                path: 'dunsNo',
                oldPath: 'business.dunsNo',
                newData: supplierRegistration,
                newPath: 'business.dunsNo',
                oldData: member,
                required: false,
              }}
            />
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(ContractDetails)
